/* eslint-disable max-len */
export const getInviteUserNotificationInfo = (
  userName = ' ',
  notificationChannel,
  accountName
) =>
  notificationChannel === 'email'
    ? `${userName} will receive an invite to ${accountName} account`
    : `${userName} will receive an invite via sms or push notification to your ${accountName} account`;
